import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';
import GalerieSectionA from '../../components/Galeries/GalerieSectionA';
import YouTubeVideos from '../../components/Sections/YouTubeVideos';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const tabContentVariants = {
  enter: { opacity: 0, x: 20 },
  center: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

const Galeries = () => {
  const [activeTab, setActiveTab] = useState('gallery'); // 'gallery' ou 'videos'

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .galeries-page {
          position: relative;
          min-height: 100vh;
          background: linear-gradient(135deg, #EAD5C0 0%, #D4B895 30%, #C69C6D 60%, #E8CFB5 100%);
          background-size: 400% 400%;
          animation: goldGradient 15s ease infinite;
          overflow: hidden;
        }

        @keyframes goldGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .galeries-page::before,
        .galeries-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.25;
          z-index: 0;
          pointer-events: none;
        }

        .galeries-page::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .galeries-page::after {
          width: 40vw;
          height: 40vw;
          background: #E8CFB5;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .content-wrapper {
          position: relative;
          z-index: 1;
        }

        /* Styles des onglets */
        .tabs-container {
          display: flex;
          justify-content: center;
          margin: 40px 0 30px;
          gap: 12px;
          position: relative;
          z-index: 3;
        }

        .tab-button {
          background: rgba(255, 255, 255, 0.6);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(198, 156, 109, 0.3);
          color: #3B2F2A;
          font-weight: 600;
          font-size: 1.1rem;
          padding: 14px 36px;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(107, 90, 70, 0.08);
          position: relative;
          overflow: hidden;
        }

        .tab-button:hover {
          background: rgba(255, 255, 255, 0.85);
          border-color: rgba(198, 156, 109, 0.6);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(184, 138, 86, 0.15);
        }

        .tab-button.active {
          background: #C69C6D;
          color: white;
          border-color: #B88A56;
          box-shadow: 0 8px 20px rgba(184, 138, 86, 0.3);
        }

        /* Indicateur actif (ligne en dessous) */
        .tab-indicator {
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: #B88A56;
          border-radius: 2px;
          transform-origin: center;
        }

        @media (max-width: 576px) {
          .tab-button {
            padding: 12px 24px;
            font-size: 1rem;
          }
        }
      `}</style>

 
      <Header />

      <motion.div
        className="galeries-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        <div className="content-wrapper" >
          {/* Onglets de navigation */}
          <motion.div
            className="tabs-container" style={{marginTop:'140px'}}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <motion.button
              className={`tab-button ${activeTab === 'gallery' ? 'active' : ''}`}
              onClick={() => setActiveTab('gallery')}
              whileTap={{ scale: 0.95 }}
            >
              📸 Galerie
            </motion.button>
            <motion.button
              className={`tab-button ${activeTab === 'videos' ? 'active' : ''}`}
              onClick={() => setActiveTab('videos')}
              whileTap={{ scale: 0.95 }}
            >
              🎥 Vidéos
            </motion.button>
          </motion.div>

          {/* Contenu de l'onglet actif avec animation de transition */}
          <AnimatePresence mode="wait">
            {activeTab === 'gallery' ? (
              <motion.div
                key="gallery"
                variants={tabContentVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.3 }}
              >
                <GalerieSectionA />
              </motion.div>
            ) : (
              <motion.div
                key="videos"
                variants={tabContentVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.3 }}
              >
                <YouTubeVideos />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>

      <Footer />
    </>
  );
};

export default Galeries;